class Animation {
    constructor() {
        this.isScrolling = false;
        this.onVisibleTargets = [];
        this.bodyElement = document.querySelector('body');


        this.registerOnVisibleElements();
        this.bindEvents();

        requestAnimationFrame(() => {
            this.triggerOnload();
            this.calculateVisibleElements();
        });
    }

    init() {
    }

    registerOnVisibleElements() {
        this.onVisibleTargets = Array.from(document.querySelectorAll('[class*="onvisible-"]'));
    }

    calculateElementPositions() {
        for (let i = 0; i < this.onVisibleTargets.length; i++) {
            this.onVisibleTargets[i].clientRect = this.onVisibleTargets[i].getBoundingClientRect();
        }
    }

    calculateVisibleElements() {
        this.calculateElementPositions();

        let removeableElements = [];
        const windowHeight = window.innerHeight || Math.max(document.documentElement.clientHeight, document.body.clientHeight);

        for (let i = 0; i < this.onVisibleTargets.length; i++) {
            if (this.onVisibleTargets[i].clientRect.top - (this.onVisibleTargets[i].clientRect.height * 0.75) <= windowHeight) {
                this.onVisibleTargets[i].classList.add('is-visible');

                removeableElements.push(i);
            }
        }

        if (removeableElements.length) {
            removeableElements.reverse();

            removeableElements.forEach(index => {
                this.onVisibleTargets.splice(index, 1);
            });
        }

        this.isScrolling = false;
    }

    bindEvents() {
        this.scrollHandler = this.handleScroll.bind(this);
        document.addEventListener('scroll', this.scrollHandler);
    }

    triggerOnload() {
        this.bodyElement.classList.add('animation-ready');
    }

    handleScroll() {
        if (!this.onVisibleTargets.length) {
            document.removeEventListener('scroll', this.scrollHandler);
            return;
        }

        if (this.isScrolling) {
            return;
        }

        this.isScrolling = true;

        requestAnimationFrame(this.calculateVisibleElements.bind(this));
    }
}

export default new Animation();
